
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[guild]/leaderboard/[pointsId]",
      function () {
        return require("private-next-pages/[guild]/leaderboard/[pointsId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[guild]/leaderboard/[pointsId]"])
      });
    }
  